module.exports = __webpack_public_path__ + "static/media/honda.cb1d9fc3.png";